import type { TaxonomyListSummary } from '@/entities/taxonomy-list';
import { resolveBoundColumnPair } from '@inference.engine/taxonomy/web';

type BindableCandidate = Pick<TaxonomyListSummary, 'id' | 'boundColumns' | 'scope'>;

/**
 * Why a list cannot be picked, or `null` when it can.
 *
 * `workspaceOnly`: an organization-wide schema opens in every workspace, and a workspace list
 * cannot be read outside its own, so the field would show no values there. The server refuses
 * the binding too.
 *
 * The field's own list stays pickable either way, so opening a form cannot hide it.
 */
export function listBindingBlock(
  list: BindableCandidate,
  ownListId?: string,
  orgWide = false,
): 'twoColumns' | 'workspaceOnly' | null {
  if (list.id === ownListId) return null;
  if (orgWide && list.scope !== 'organization') return 'workspaceOnly';
  return resolveBoundColumnPair(list.boundColumns) ? null : 'twoColumns';
}
